/**
 * Calendar arithmetic on `YYYY-MM-DD` strings (docs/06 §2). The parser never touches time zones:
 * it receives «today» already computed in the user's zone and returns calendar dates, which is
 * what `blocks.due_on` and `blocks.start_on` store.
 */
export function parseDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match)
        throw new Error(`Not a calendar date: ${value}`);
    return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
}
export function formatDate({ year, month, day }) {
    return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
function toUtc({ year, month, day }) {
    return new Date(Date.UTC(year, month - 1, day));
}
function fromUtc(date) {
    return { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate() };
}
export function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month, 0)).getUTCDate();
}
export function isValidDate(year, month, day) {
    return month >= 1 && month <= 12 && day >= 1 && day <= daysInMonth(year, month);
}
export function addDays(date, days) {
    const utc = toUtc(parseDate(date));
    utc.setUTCDate(utc.getUTCDate() + days);
    return formatDate(fromUtc(utc));
}
/** Adds calendar months, clamping the day to the end of the target month (31/1 + 1 month = 28/2). */
export function addMonths(date, months) {
    const { year, month, day } = parseDate(date);
    const index = year * 12 + (month - 1) + months;
    const targetYear = Math.floor(index / 12);
    const targetMonth = (index % 12) + 1;
    return formatDate({
        year: targetYear,
        month: targetMonth,
        day: Math.min(day, daysInMonth(targetYear, targetMonth)),
    });
}
/** ISO weekday: 1 = Monday … 7 = Sunday (the week starts on Monday, docs/06 §2). */
export function isoWeekday(date) {
    const weekday = toUtc(parseDate(date)).getUTCDay();
    return weekday === 0 ? 7 : weekday;
}
export function compareDates(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
//# sourceMappingURL=calendar.js.map